import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useTeamModel } from "../teamModel";
import { ITeamDetail } from "../teamTypes";
import { momentFormat } from "@/utils/utils";
import { Image } from 'antd';
import { loadFileUrl } from "@/utils/constants";
import { getCOSFileUrl } from "@/utils/uploadFile";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, selectedRow,
        loadData, setSelectedRowKeys, setSelectedRow
    } = useTeamModel();
    const columns: ColumnsType<ITeamDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (text, record, index) => `${index + 1}`
        }, {
            title: '缩略图',
            width: 160,
            fixed: "left",
            // render: (text: string, record: any) => <Image width={60} src={loadFileUrl(record?.list[0]?.imgMd5 as string)} alt="" />
            // render: (text: string, record: any) => record?.list?.map((item:any)=><Image width={60} src={loadFileUrl(item.imgMd5 as string)} alt="图片" />)
            render: (text: string, record: any) => record?.list?.map((item: any) => <Image width={60} src={getCOSFileUrl(item.imgMd5 as string)} alt="图片" />)
        }, {
            title: '标题',
            width: 400,
            fixed: "left",
            dataIndex: 'title',
        }, {
            title: '创建人',
            width: 160,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 160,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '备注',
            // width: 200,
            dataIndex: 'note'
        }
    ];
    useEffect(() => {
        loadData()
    }, []);

    //点击行选高亮
    const onRow = (record: ITeamDetail) => {
        // let findIndex = selectedRowKeys.indexOf(id);
        let { id } = record as { id: string };
        let findIndexDesc = selectedRow.findIndex((item) => (item.id === id));
        let newDescRows = [...selectedRow];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
            //表格选中值
            newDescRows.push(record);
            setSelectedRow(newDescRows);
        } else {
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
            //表格选中值
            newDescRows.splice(findIndexDesc,1);
            setSelectedRow(newDescRows);
        }
    };
    const onRightClick = (record: ITeamDetail)=>{
        setSelectedRow([record]);
        setSelectedRowKeys([record.id as string])
    }
    return (
        <Table
            rowKey={record => record.id as string}
            rowSelection={{
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: ITeamDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setSelectedRow(selectedRows)
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    onRightClick(record)
                }
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
